import { useState } from 'react';
import { api } from '../api.js';

// One-time note for a keeper who was getting the morning email before
// email moved to "only what needs you" (2026-09-29). The server sets
// email_prefs.email_v2_notice for them; either button clears it. It hides
// itself rather than re-fetching the session: that refresh signs the keeper
// out on any network error.
export function EmailChangeNote({ user, onOpenAccount, order, style }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [hidden, setHidden] = useState(false);
  const prefs = user?.email_prefs && typeof user.email_prefs === 'object' ? user.email_prefs : null;
  if (hidden || !prefs || prefs.email_v2_notice !== true) return null;

  const answer = async (keepMorning) => {
    setBusy(true);
    setErr('');
    try {
      await api('/api/auth/me', {
        method: 'PATCH',
        body: {
          email_prefs: {
            ...prefs,
            ...(keepMorning ? { digest: true } : {}),
            email_v2_notice: false,
          },
        },
      });
      setHidden(true);
    } catch (e) {
      setErr(e.message || 'Could not save.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section
      className="slide-in span-2"
      style={{
        order: typeof order === 'number' ? order : undefined,
        ...style,
        borderRadius: 16,
        padding: 14,
        background: 'var(--accent-bg)',
        border: '1px solid var(--accent-border)',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      <div
        className="font-heading"
        style={{
          fontSize: 12,
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: 'var(--cyan)',
        }}
      >
        Fewer emails
      </div>
      <p style={{ fontSize: 15, lineHeight: 1.45, color: 'var(--text)', margin: 0 }}>
        Day to day, we now email you only when something needs you: a reading far out of range, or a
        display or probe gone quiet. The morning summary is off. Want it back?
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        <button
          type="button"
          className="ts-chip"
          disabled={busy}
          style={{ minHeight: 44, background: 'var(--cyan)', color: 'var(--cyan-text)' }}
          onClick={() => answer(true)}
        >
          Keep the morning email
        </button>
        <button
          type="button"
          className="ts-chip"
          disabled={busy}
          style={{ minHeight: 44 }}
          onClick={() => answer(false)}
        >
          No thanks
        </button>
        {onOpenAccount && (
          <button
            type="button"
            className="ts-chip"
            disabled={busy}
            style={{ minHeight: 44 }}
            onClick={onOpenAccount}
          >
            Choose emails
          </button>
        )}
      </div>
      {err && (
        <div role="alert" className="ts-err">
          {err}
        </div>
      )}
    </section>
  );
}
